var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formatter',{staticClass:"content",attrs:{"text":_vm.formattedText}},[_vm._l((_vm.links),function(linkText,linkName){return _c('template',{slot:linkName},[_c('a',{attrs:{"href":_vm.links[linkName],"target":"_blank"}},[_vm._v(_vm._s(_vm.links[linkName]))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }